import React from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

const Layout = ({ children }) => {
  return (
    <>
     
      <div className="topbar">
        <div className="container topbar-container">
          <h2 className="topbar-main">INSTITUTE OF HOTEL MANAGEMENT CATERING <br/>TECHNOLOGY & APPLIED NUTRITION MUMBAI</h2>

          <h4 className="topbar-subtitle">
           
          </h4>

          <p className="topbar-hindi">
           होटल प्रबंधन प्रौद्योगिकी एवं अनुप्रयुक्त पोषक विज्ञान संस्थान, मुंबई
          </p>

          <div className="topbar-divider-line">
            <span className="dot"></span>
          </div>

          <p className="topbar-eng">
            An Autonomous Body under Ministry of Tourism, Government of India
          </p>

          <p className="topbar-hindi-sub">
            पर्यटन मंत्रालय भारत सरकार के अधीन स्वायत्तशासी निकाय
          </p>
        </div>
      </div>
      
      <Header />
      {children}
      <Footer />
    </>
  );
};

export default Layout;
